import TextOptionPresenter from './TextOptionPresenter';

class ProductPresenter {
  rules = [];

  constructor(product, rules) {
    this.product = product;
    if (rules) {
      this.rules = rules;
    }

    this.attachEventListener();
  }

  initializeOptions() {
    const inputTextValueElem = document.querySelectorAll( '.bold_option_element input[type=text]' );

      this.optionPresenters = [...inputTextValueElem].map(textInput => {
        const regex = new RegExp(/properties\[(.*)\]/);
        const optionName = textInput.name.match(regex)[1];
        const matchedRule = rule => rule.title.toLowerCase() === optionName.toLowerCase();
        const overrideRules = this.rules.find(matchedRule) ;

        document.querySelector('form[action="/cart/add"] button[type="submit"]').addEventListener('click', this.validateOptionsForSubmit.bind(this));

        return new TextOptionPresenter(textInput, overrideRules);
      });
 
    BOLD.common.eventEmitter.on('BOLD_OPTIONS_validation_failed', this.validateOptions.bind(this));
    BOLD.common.eventEmitter.on('BOLD_OPTIONS_validation_passed', this.validateOptions.bind(this));
  }

  validateOptionsForSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    const formIsInvalid = this.optionPresenters.some(optionPresenter => optionPresenter.isOptionValid() == false);
    if (!formIsInvalid ) {
      event.target.form.submit();
    } else {
      this.optionPresenters.forEach(optionPresenter => optionPresenter.isOptionValid());
    }
  }

  validateOptions() {
    this.optionPresenters.forEach(optionPresenter => optionPresenter.isOptionValid());
  }

  activateButtons() {
    const atcButton = document.querySelector('.bold_clone');
    if(!atcButton){
      return;
    }
    atcButton.classList.add('enabled-button');
  }
  
  attachEventListener() {
    var attempts = 1;
    var maxAttempts = 40;
    
    const tryInit = () => {
      const atcButton = document.querySelector('.bold_clone');
      
      if (atcButton) {
        BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', this.initializeOptions());
        this.activateButtons();
        clearInterval(waitForOptions);
        
      } else if(attempts === maxAttempts) {
        clearInterval(waitForOptions);
      } else {
        attempts++;
      }
    }
    var waitForOptions = setInterval(tryInit, 100);
  }
}
export default ProductPresenter;
